<template>
  <div
    :class="{'open-page-circles':!pageOpen, 'open-page-circles--reverse':pageOpen}"
    ref="circles"
  >
    <div class="circle-wrap circleOpen large">
      <svg
        version="1.1"
        baseProfile="tiny"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 200 200"
        xml:space="preserve"
      >
        <g>
          <circle class="black" cx="100" cy="100" r="100"></circle>
        </g>
      </svg>
    </div>
    <div class="circle-wrap circleOpen medium">
      <svg
        version="1.1"
        baseProfile="tiny"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 200 200"
        xml:space="preserve"
      >
        <g>
          <circle class="black" cx="100" cy="100" r="100"></circle>
        </g>
      </svg>
    </div>
    <div class="circle-wrap circleOpen small">
      <svg
        version="1.1"
        baseProfile="tiny"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 200 200"
        xml:space="preserve"
      >
        <g>
          <circle class="black" cx="100" cy="100" r="100"></circle>
        </g>
      </svg>
    </div>
    <div class="circle-wrap circleOpen pink">
      <svg
        version="1.1"
        baseProfile="tiny"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 200 200"
        xml:space="preserve"
      >
        <g>
          <circle class="pink" cx="100" cy="100" r="100"></circle>
        </g>
      </svg>
    </div>
  </div>
</template>
<script>
let delay = {
  interval: 0.125,
  start: 0.125
};
let reverseDelay = {
  interval: 0.066,
  start: 0
};
import Circle from "./svg/Circle.vue";
export default {
  data() {
    return {
      childCount: 0,
      delay: delay
    };
  },
  props: ["pageOpen"],
  components: {
    appCircle: Circle
  },
  mounted() {
    Object.entries(this.$refs).forEach(([key, value]) => {
      for (let svg of value.children) {
        this.childCount++;
      }
    });
    if (this.pageOpen) {
      this.delay = delay;
    } else {
      this.delay = reverseDelay;
      this.delay.start = this.childCount;
    }
    let currentDelay = this.delay.interval * this.delay.start;
    Object.entries(this.$refs).forEach(([key, value]) => {
      for (let svg of value.children) {
        svg.style.animationDelay = `${currentDelay}s`;
        if (this.pageOpen) {
          currentDelay += this.delay.interval;
        } else {
          currentDelay -= this.delay.interval;
        }
      }
    });
  }
};
</script>